module.exports = __webpack_public_path__ + "media/components/country-flag/static/kn-ae8c5fb95d18b4db96b58d84f3cbcfd1.svg";